module.exports = "/_next/static/images/43eb7cad4ec26599b430af06b734e7e0-hero-mobile-v1.jpg.webp";